import { Injectable } from '@angular/core';
import { OperationShiftEmployeeConstants } from '../constants/user-constants/operation-shift-employee.constants';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { RequestResponse } from '../models/request-response.model';
import { BaseTableColumns } from '../models/table-columns/admin-table-columns.model';

@Injectable({
    providedIn: 'root'
})
export class OperationEmployeeService {
    requestsAssignedToMeView = VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS;
    completedRequestsView = VIEW_TYPE.COMPLETED_REQUESTS;
    completedHistoryRequests=VIEW_TYPE.COMPLETED_HISTORY_REQUESTS;
    
    constructor() {}

    convertResponseToTableData(viewType: string, response: RequestResponse) {
        return new BaseTableColumns(
            response.id,
            response.requesterData.name,
            response.service.name,
            response.requesterData.client ? response.requesterData.client.name : 'N/A',
            response.createdAt
        );
    }

    getTableColumns(requestObjectName: string) {
        return OperationShiftEmployeeConstants[requestObjectName].tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = OperationShiftEmployeeConstants[requestObjectName].tableColumn.map(c => c.columnDef);
        const tableWithSelection = OperationShiftEmployeeConstants[requestObjectName].tableWithSelection;
        if (tableWithSelection) {
            displayColumns.unshift('select');
        }

        return displayColumns;
    }

    isTableWithSelection(requestObjectName: string) {
        return OperationShiftEmployeeConstants[requestObjectName].tableWithSelection;
    }

    getSideMenu() {
        const list = [OperationShiftEmployeeConstants.ASSIGNED_TO_ME_REQUESTS, OperationShiftEmployeeConstants.COMPLETED_REQUESTS,OperationShiftEmployeeConstants.COMPLETED_HISTORY_REQUESTS
        ];
        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
}
